module.exports = __webpack_public_path__ + "img/qr-sample.172e1e7f.svg";